import { render, staticRenderFns } from "./detail_management.vue?vue&type=template&id=613ea79a&scoped=true&"
import script from "./detail_management.vue?vue&type=script&lang=js&"
export * from "./detail_management.vue?vue&type=script&lang=js&"
import style0 from "./detail_management.vue?vue&type=style&index=0&id=613ea79a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613ea79a",
  null
  
)

export default component.exports